import { SERVICE } from '@src/constants';
import api from './api';

export const getPackages = async (organizationId, appId, params) => {
  const res = await api({
    method: 'GET',
    url: `/organizations/${organizationId}/apps/${appId}/packages`,
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};
